<template>
  <!-- Side by side from the sm breakpoint up; stacks on phones, where the card
       fills the viewport and two name fields would be too cramped. -->
  <div class="row gap-md full-width">
    <div class="col-sm column col-12 gap-xs no-wrap">
      <label
        for="onboarding-first-name"
        class="text-14 text-font-semibold"
      >
        {{ copy.firstNameLabel }}
      </label>
      <q-input
        v-model="firstName"
        for="onboarding-first-name"
        v-bind="FIELD_CHROME.form"
        dense
        :maxlength="MAX_LENGTH.SHORT_TEXT"
        :disable="disable"
      />
    </div>

    <div class="col-sm column col-12 gap-xs no-wrap">
      <label
        for="onboarding-last-name"
        class="text-14 text-font-semibold"
      >
        {{ copy.lastNameLabel }}
      </label>
      <q-input
        v-model="lastName"
        for="onboarding-last-name"
        v-bind="FIELD_CHROME.form"
        dense
        :maxlength="MAX_LENGTH.SHORT_TEXT"
        :disable="disable"
      />
    </div>
  </div>
</template>

<script setup>
  import { FIELD_CHROME, MAX_LENGTH, ONBOARDING_COPY } from 'src/services/consts/app.const'

  const firstName = defineModel('firstName', { type: String, required: true })
  const lastName = defineModel('lastName', { type: String, required: true })

  defineProps({
    disable: {
      type: Boolean,
      default: false,
    },
  })

  const copy = ONBOARDING_COPY.nameFields
</script>
